export default "__VITE_PUBLIC_ASSET__c1c8a5a4__"